import { TrendingFlat } from "@mui/icons-material";
import { Skeleton, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ListCard } from "src/components/Assistant/LoadingDocuments";
import { PageBreadcrumb } from "src/components/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";
import { ROUTE_SLUGS, ROUTES } from "src/config/navigation/routes";
import { useCrisp } from "src/hooks/Crisp";
import { useGetDevice } from "src/hooks/queries";
import { usePostAssistantProcessMutation } from "src/hooks/queries/assistant-process-mutations";
import { fillRouteWithSlugs } from "src/utils/navigation";

export const Assistant = () => {
  const { deviceId = "", orgId = "" } = useParams();
  const { supportOpen, setSupportOpen } = useCrisp();
  const navigate = useNavigate();
  const { data: device } = useGetDevice({ orgId, deviceId });
  const postAssistantProcess = usePostAssistantProcessMutation();

  return (
    <div className="flex flex-1 flex-col gap-y-6">

      <PageHeader
        pageTitleComponent={
          <PageBreadcrumb
            items={[
              {
                label: device ? device.name : <Skeleton width={100} />,
              },
              { label: "Assistant" },
            ]}
          />
        }
      />



      <div className="flex flex-col gap-y-3 py-2 px-3">
        <Typography>
          Get help completing some common tasks with our assistant.
        </Typography>
        <ListCard
          text="I need help knowing what documents to change or update."
          EndIcon={TrendingFlat}
          onClick={async () => {
            await postAssistantProcess.mutateAsync({
              data: {
                state: {
                  changeType: "update",
                  currentPath: ROUTES.ASSISTANT_DU_CONFIGURE,
                  checkboxes: [],
                  description: "",
                  changes: [],
                  dataKeysToUpdate: [],
                },
              },
              orgId,
              deviceId,
            });
            navigate(
              fillRouteWithSlugs(ROUTES.ASSISTANT_DU_CONFIGURE, {
                [ROUTE_SLUGS.ORG_ID]: orgId,
                [ROUTE_SLUGS.DEVICE_ID]: deviceId,
              })
            );
          }}
        />
        <ListCard
          text="I'd like to get some help from a human"
          EndIcon={TrendingFlat}
          onClick={() => setSupportOpen(!supportOpen)}
        />
        <ListCard
          text="Terminal"
          EndIcon={TrendingFlat}
          onClick={() => {
            navigate(
              fillRouteWithSlugs(ROUTES.TERMINAL, {
                [ROUTE_SLUGS.ORG_ID]: orgId,
                [ROUTE_SLUGS.DEVICE_ID]: deviceId,
              })
            );
          }}
        />
      </div>
    </div>
  );
};
